import {
    LIST_HADITH_SUCCESS,
    LIST_HADITHS_SUCCESS,
    LIST_HADTIH_FAILURE,
    LIST_HADTIHS_FAILURE, SET_HADITH_IS_LOADING,
    SET_HADITHS_IS_LOADING,
} from './actionTypes';
import { listHadithAPI, listHadithsAPI } from '../api/hadithAPI';

function listHadithSuccess(data) {
    return { data, type: LIST_HADITHS_SUCCESS };
}

function listHadithFailure(response) {
    return { response, type: LIST_HADTIHS_FAILURE };
}

function hadithSuccess(data) {
    return { data, type: LIST_HADITH_SUCCESS };
}

function hadithFailure(response) {
    return { response, type: LIST_HADTIH_FAILURE };
}

export function listHadith(hadithId) {
    return dispatch => listHadithAPI(hadithId)
        .then(response => dispatch(hadithSuccess(response.data)))
        .catch(response => dispatch(hadithFailure(response)));
}
export function listHadiths(offset) {
    return dispatch => listHadithsAPI(offset)
        .then(response => dispatch(listHadithSuccess(response.data)))
        .catch(response => dispatch(listHadithFailure(response)));
}

export function setHadithsIsLoadingTrue() {
    return dispatch => dispatch({ type: SET_HADITHS_IS_LOADING });
}

export function setHadithIsLoadingTrue() {
    return dispatch => dispatch({ type: SET_HADITH_IS_LOADING });
}
